import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from "@mui/material";

import { initializeCoverage, getCoverage } from '../coverageSlice';

import Spinner from '../../../components/ph/Spinner/Spinner';

import CoverageSelectorHeader from "../components/CoverageSelectorHeader";
import CoverageCarousel from "../components/CoverageCarousel";

const CoverageSelector = () => {
    const dispatch = useDispatch();
    const { plans, error, status, uuid } = useSelector((state) => state.coverage);

    useEffect(() => {
        dispatch(initializeCoverage());
    }, [dispatch]);

    useEffect(() => {
        if (uuid) {
            dispatch(getCoverage({ uuid }));
        }
    }, [uuid, dispatch]);

    if (status === 'loading') {
        return (
            <Spinner 
                variant="yellow"
                size={60}
            />
        );
    }

    return (
        <Container
            maxWidth="md"
            disableGutters={{ 
                xs: true, 
                md: false 
            }}
            sx={{
                py: 2,
                px: { xs: 2, md: 3 }
            }}>
            <CoverageSelectorHeader />
            <CoverageCarousel plans={plans}/>
        </Container>
    );
};

export default CoverageSelector;